import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import SeminarAdmin from './SeminarAdmin';
import PartnerAdmin from './PartnerAdmin';
import TestimonialAdmin from './TestimonialAdmin';
import DownloadAdmin from './DownloadAdmin';
import FileManager from './FileManager';
import MailAdmin from './MailAdmin';
import LogoAdmin from './LogoAdmin';
import CRMAdmin from './CRMAdmin';
import BookingAdmin from './BookingAdmin';
import MLAdmin from './MLAdmin';
import EventAdmin from './EventAdmin';

const topNavItems = [
  { id: 'hp', label: 'ホームページ関連' },
  { id: 'mail', label: 'メール管理' },
  { id: 'event', label: 'イベント管理' },
  { id: 'crm', label: '顧客管理機能' },
  { id: 'booking', label: '予約管理' },
];

const hpMenuItems = [
  { id: 'seminars', label: 'セミナー管理' },
  { id: 'partners', label: 'パートナー事務所' },
  { id: 'logos', label: 'パートナーロゴ' },
  { id: 'testimonials', label: 'お客様の声' },
  { id: 'downloads', label: 'ダウンロード資料' },
  { id: 'files', label: 'ファイル管理' },
];

const mailMenuItems = [
  { id: 'mail_inbox', label: 'お問い合わせ' },
  { id: 'ml_lists', label: 'MLリスト一覧' },
  { id: 'ml_compose', label: 'ML一斉送信' },
  { id: 'ml_history', label: 'ML送信履歴' },
];

const eventMenuItems = [
  { id: 'event_list', label: 'イベント一覧' },
  { id: 'event_members', label: '参加者管理' },
];

const crmMenuItems = [
  { id: 'crm_all', label: '顧客一覧' },
  { id: 'crm_seminar', label: 'セミナー参加者' },
  { id: 'crm_academy', label: 'アカデミー関連' },
  { id: 'crm_partner', label: 'パートナー候補' },
  { id: 'crm_inquiry', label: '問い合わせ中' },
  { id: 'crm_replied', label: '対応済み' },
];

const AdminDashboard = () => {
  const [authed, setAuthed] = useState(localStorage.getItem('admin_auth') === 'true');


  const getStateFromHash = () => {
    const hash = window.location.hash.replace('#', '');
    if (hash === 'booking') return { section: 'booking', page: 'booking' };
    const mailPages = mailMenuItems.map((m) => m.id);
    if (hash === 'mail' || mailPages.includes(hash)) return { section: 'mail', page: mailPages.includes(hash) ? hash : 'mail_inbox' };
    const eventPages = eventMenuItems.map((m) => m.id);
    if (hash === 'event' || eventPages.includes(hash)) return { section: 'event', page: eventPages.includes(hash) ? hash : 'event_list' };
    const crmPages = crmMenuItems.map((m) => m.id);
    if (hash === 'crm' || crmPages.includes(hash)) return { section: 'crm', page: crmPages.includes(hash) ? hash : 'crm_all' };
    const hpPages = hpMenuItems.map((m) => m.id);
    if (hpPages.includes(hash)) return { section: 'hp', page: hash };
    return { section: 'hp', page: 'seminars' };
  };

  const initial = getStateFromHash();
  const [activeSection, setActiveSection] = useState(initial.section);
  const [activePage, setActivePage] = useState(initial.page);

  useEffect(() => {
    const onHashChange = () => {
      const state = getStateFromHash();
      setActiveSection(state.section);
      setActivePage(state.page);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    document.title = '管理画面 | SrWith';
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    meta.content = 'noindex, nofollow';
    return () => { meta.content = ''; };
  }, []);

  if (!authed) {
    return <AdminLogin onLogin={() => {
      localStorage.setItem('admin_auth', 'true');
      setAuthed(true);
    }} />;
  }

  const handleLogout = () => {
    localStorage.removeItem('admin_auth');
    setAuthed(false);
  };

  const switchSection = (id) => {
    setActiveSection(id);
    if (id === 'hp') { setActivePage('seminars'); window.location.hash = 'seminars'; }
    if (id === 'mail') { setActivePage('mail_inbox'); window.location.hash = 'mail_inbox'; }
    if (id === 'event') { setActivePage('event_list'); window.location.hash = 'event_list'; }
    if (id === 'crm') { setActivePage('crm_all'); window.location.hash = 'crm_all'; }
    if (id === 'booking') { setActivePage('booking'); window.location.hash = 'booking'; }
  };

  const renderPage = () => {
    switch (activePage) {
      case 'mail_inbox': return <MailAdmin />;
      case 'ml_lists': return <MLAdmin initialTab="lists" />;
      case 'ml_compose': return <MLAdmin initialTab="compose" />;
      case 'ml_history': return <MLAdmin initialTab="history" />;
      case 'seminars': return <SeminarAdmin />;
      case 'partners': return <PartnerAdmin />;
      case 'testimonials': return <TestimonialAdmin />;
      case 'logos': return <LogoAdmin />;
      case 'downloads': return <DownloadAdmin />;
      case 'files': return <FileManager />;
      case 'event_list': return <EventAdmin page="event_list" onNavigate={(p) => { setActivePage(p); window.location.hash = p; }} />;
      case 'event_members': return <EventAdmin page="event_members" onNavigate={(p) => { setActivePage(p); window.location.hash = p; }} />;
      case 'crm_all': return <CRMAdmin filter="all" />;
      case 'crm_seminar': return <CRMAdmin filter="セミナー" />;
      case 'crm_academy': return <CRMAdmin filter="アカデミー" />;
      case 'crm_partner': return <CRMAdmin filter="パートナー" />;
      case 'crm_inquiry': return <CRMAdmin filter="未対応" />;
      case 'crm_replied': return <CRMAdmin filter="対応済み" />;
      case 'booking': return <BookingAdmin />;
      default: return null;
    }
  };

  const getSidebarItems = () => {
    if (activeSection === 'hp') return hpMenuItems;
    if (activeSection === 'mail') return mailMenuItems;
    if (activeSection === 'event') return eventMenuItems;
    if (activeSection === 'crm') return crmMenuItems;
    return null;
  };

  const sidebarItems = getSidebarItems();

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* トップナビ */}
      <header className="bg-gray-900 text-white px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <h1 className="text-lg font-bold shrink-0">SrWith 管理</h1>
          <nav className="flex gap-1">
            {topNavItems.map((item) => (
              <button
                key={item.id}
                onClick={() => switchSection(item.id)}
                className={`px-4 py-1.5 rounded text-sm font-bold transition-colors ${
                  activeSection === item.id
                    ? 'bg-gray-700 text-white'
                    : 'text-gray-400 hover:text-white hover:bg-gray-800'
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-4">
          <a href="/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors">
            ホームページを開く
          </a>
          <button onClick={handleLogout} className="text-sm text-gray-400 hover:text-white transition-colors">
            ログアウト
          </button>
        </div>
      </header>

      <div className="flex flex-1">
        {/* 左サイドバー */}
        {sidebarItems && (
          <aside className="w-52 bg-gray-800 text-white flex flex-col shrink-0">
            <nav className="flex-1 py-4">
              {sidebarItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => { setActivePage(item.id); window.location.hash = item.id; }}
                  className={`w-full text-left px-5 py-3 text-sm transition-colors ${
                    activePage === item.id
                      ? 'bg-gray-700 text-white'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </aside>
        )}

        {/* メインコンテンツ */}
        <main className="flex-1 p-8 overflow-y-auto">
          {renderPage()}
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
